import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import EventManagePage from "@/pages/EventManagePage";
import GuestLandingPage from "@/pages/GuestLandingPage";
import GuestCapturePage from "@/pages/GuestCapturePage";
import GuestGalleryPage from "@/pages/GuestGalleryPage";
import VipShowcasePage from "@/pages/VipShowcasePage";
import VipApplyPage from "@/pages/VipApplyPage";
import AdminPage from "@/pages/AdminPage";
import SlideshowPage from "@/pages/SlideshowPage";
import HallOfFamePage from "@/pages/HallOfFamePage";

function ProtectedRoute({ children, roles }) {
  const { user, checking } = useAuth();
  if (checking)
    return (
      <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center">
        <div className="text-white/50">Carregando...</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "rgba(11,9,20,0.95)",
                border: "1px solid rgba(255,0,127,0.4)",
                color: "#fff",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/vitrine-vip" element={<VipShowcasePage />} />
            <Route path="/vip-apply" element={<VipApplyPage />} />
            <Route path="/e/:slug" element={<GuestLandingPage />} />
            <Route path="/e/:slug/capture" element={<GuestCapturePage />} />
            <Route path="/e/:slug/gallery" element={<GuestGalleryPage />} />
            <Route path="/e/:slug/slideshow" element={<SlideshowPage />} />
            <Route path="/e/:slug/hall" element={<HallOfFamePage />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute roles={["organizer", "vip", "admin"]}>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/events/:id"
              element={
                <ProtectedRoute roles={["organizer", "vip", "admin"]}>
                  <EventManagePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminPage />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
